class CustomTabs {
  constructor() {
    this.init();
  }

  init() {
    const tabContainers = document.querySelectorAll('.custom-tabs');
    console.log('Found tab containers:', tabContainers.length);
    
    tabContainers.forEach((container, index) => {
      const tabs = container.querySelectorAll('.custom-tabs__tab');
      const panels = container.querySelectorAll('.custom-tabs__panel');
      
      console.log(`Container ${index + 1}:`, {
        tabs: tabs.length,
        panels: panels.length,
        tabData: Array.from(tabs).map(t => t.getAttribute('data-tab')),
        panelData: Array.from(panels).map(p => p.getAttribute('data-tab'))
      });
      
      // 确保第一个标签和面板是激活状态
      if (tabs.length > 0 && panels.length > 0) {
        // 移除所有活动状态
        tabs.forEach(t => t.classList.remove('custom-tabs__tab--active'));
        panels.forEach(p => p.classList.remove('custom-tabs__panel--active'));
        
        // 激活第一个
        tabs[0].classList.add('custom-tabs__tab--active');
        panels[0].classList.add('custom-tabs__panel--active');
        console.log(`Container ${index + 1}: First tab and panel activated`);
      }
      
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const targetTab = tab.getAttribute('data-tab');
          console.log('Tab clicked:', targetTab);
          
          // 移除所有活动状态
          tabs.forEach(t => t.classList.remove('custom-tabs__tab--active'));
          panels.forEach(p => p.classList.remove('custom-tabs__panel--active'));
          
          // 添加活动状态到当前标签和面板
          tab.classList.add('custom-tabs__tab--active');
          const targetPanel = container.querySelector(`.custom-tabs__panel[data-tab="${targetTab}"]`);
          console.log('Target panel found:', targetPanel);
          console.log('Target panel HTML:', targetPanel ? targetPanel.outerHTML : 'Not found');
          console.log('Target panel classes before:', targetPanel ? targetPanel.className : 'N/A');
          
          if (targetPanel) {
            targetPanel.classList.add('custom-tabs__panel--active');
            console.log('Panel activated:', targetTab);
            console.log('Target panel classes after:', targetPanel.className);
            console.log('Target panel computed display:', window.getComputedStyle(targetPanel).display);
            
            // 检查面板内容
            const panelContent = targetPanel.innerHTML;
            console.log('Panel content length:', panelContent.length);
            console.log('Panel content preview:', panelContent.substring(0, 200));
          } else {
            console.error('Panel not found for tab:', targetTab);
          }
        });
      });
    });
  }
}

// 当DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing CustomTabs');
  try {
    new CustomTabs();
  } catch (error) {
    console.error('Error initializing CustomTabs:', error);
  }
});

// 如果页面使用Turbo或其他SPA框架，也需要在页面变化时重新初始化
document.addEventListener('shopify:section:load', () => {
  console.log('Shopify section loaded, initializing CustomTabs');
  try {
    new CustomTabs();
  } catch (error) {
    console.error('Error initializing CustomTabs:', error);
  }
});

// 备用初始化方法
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM loaded (backup), initializing CustomTabs');
    try {
      new CustomTabs();
    } catch (error) {
      console.error('Error initializing CustomTabs (backup):', error);
    }
  });
} else {
  console.log('DOM already loaded, initializing CustomTabs immediately');
  try {
    new CustomTabs();
  } catch (error) {
    console.error('Error initializing CustomTabs (immediate):', error);
  }
}
